"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ALIGNMENT = exports.EXPAND_TYPE = void 0;
var EXPAND_TYPE = {
  FULL: 'FULL',
  SIDEBAR: 'SIDEBAR',
  DRAWER: 'DRAWER'
};
exports.EXPAND_TYPE = EXPAND_TYPE;
var ALIGNMENT = {
  CENTER: 'CENTER',
  LEFT: 'LEFT'
};
exports.ALIGNMENT = ALIGNMENT;